import { Component, Input } from '@angular/core';
import { NgbActiveModal, NgbModal } from '@ng-bootstrap/ng-bootstrap';
import { SalesEntityService } from 'app/layout/sales-entity/sales-entity-service/sales-entity-service';
import { BindingContext } from 'app/shared/models/BindingContext';
import { HttpErrorResponse } from '@angular/common/http';
import { SubscriptionLike as ISubscription } from 'rxjs';
import { FormGroup, FormControl, Validators } from '@angular/forms';
import { FormatService } from 'app/shared/services/format.service';
import { CompPlan, CompPlanTier, SalesEntityAddress } from 'app/shared/models/EvoSalesPortalModel';
import { FormsValidationService } from 'app/shared/services/formsValidation.service';
import { UserAccessService } from 'app/shared/services/user-access.service';
import { KeyValuePair } from 'app/shared/classes/key-value-pair';
import { E_PriceLists } from 'app/shared/models/EcommissionsModels';


@Component({
    selector: 'se-tier-editor-modal',
    styleUrls: ['se-tier-editor.scss'],
    templateUrl: 'se-tier-editor.html',
})
export class SalesEntityCompPlanTierEditorModalComponent {
    bindingContext: BindingContext = new BindingContext();
    private formValidatorSub: ISubscription;
    seForm: FormGroup;
    private subscription: ISubscription;
    public DefaultPriceList: Array<E_PriceLists> = new Array<E_PriceLists>();
    @Input() CompPlan: CompPlan;
    @Input() salesEntityID: number;
    saving: boolean = false;
    ActionType: string = "Add";
    private _formValid: boolean;
    public set FormValid(input: boolean) {
        this._formValid = input;
    }
    public get FormValid(): boolean {
        return this._formValid;
    }
    public get States() {
        //console.log("State Data: ", this.seSvc.StateDropdownData());
        return this.seSvc.StateDropdownData();
    }

    constructor(public activeModal: NgbActiveModal,
        private seSvc: SalesEntityService,
        private formSvc: FormsValidationService,
        private accSvc: UserAccessService) {
        this.bindingContext.isBusy = false;
        this.CreateForm();
    }

    ngOnInit() {
        this.getPriceLists();
    }

    ngOnDestroy() {
        if (this.subscription) { this.subscription.unsubscribe(); }
        if (this.formValidatorSub) { this.formValidatorSub.unsubscribe(); }
    }

    /**
    * Builds the formGroup for this input
    * @ Subscribes to form changes and binds the validity to the FormValid property
    */
    CreateForm() {
        //Create the form and it's validators
        this.seForm = new FormGroup({
            TierThreshold: new FormControl('', [Validators.required, Validators.pattern('^(0|[1-9][0-9]*)$')]),
            PriceListID: new FormControl('', [Validators.required]),
            ContractPercentage: new FormControl('', [Validators.required, Validators.max(100), Validators.min(0)]),
        });
        //Subscribe to form change events and validate dirty fields
        this.formValidatorSub = this.seForm.valueChanges.subscribe((data) => {
            //console.log(this.seForm.controls);
            this.FormValid = this.formSvc.formIsValid(this.seForm, true);
        });
    }

    onSubmit() {
        this.saving = true;
        let temp = new CompPlanTier();
        this.formSvc.BindFormGroupToData(this.seForm, temp, true);
        temp.CompPlanID = this.CompPlan.CompPlanID;
        console.log('SUBMISSION:', temp);
        this.seSvc.insertTier(temp).toPromise().then(resp => {
            this.saving = false;
            this.activeModal.close(true);
        }).catch((resp: HttpErrorResponse) => {
            this.bindingContext.endGet();
            this.saving = false;
            alert('There was an error saving tier, please try again. Contact support if this problem persists.');
        });
    }

    /**
       * Gets price lists for dropdowns
       */
    getPriceLists() {
        this.seSvc.getPricingList(this.salesEntityID).then(resp => {
            this.DefaultPriceList = resp;
            console.log("DefaultPriceList:", this.DefaultPriceList);
        }).catch((resp: HttpErrorResponse) => {
            //handle
        });
    }

    public canSave() {
        if (!this.seForm.dirty || !this.seForm.valid) {
            //The whole form dirty or not must be valid
            //And you can't submit anyway unless it's dirty
            return false;
        } else {
            //The form is dirty AND not valid
            return true;
        }
    }
}
